import { render, staticRenderFns } from "./roomCard.vue?vue&type=template&id=7ae31b3f&scoped=true"
import script from "./roomCard.vue?vue&type=script&lang=js"
export * from "./roomCard.vue?vue&type=script&lang=js"
import style0 from "./roomCard.vue?vue&type=style&index=0&id=7ae31b3f&lang=scss&scoped=true"
import style1 from "./roomCard.vue?vue&type=style&index=1&id=7ae31b3f&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae31b3f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3875257498/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/364953906322/ap-northeast-1/84d36ee7-16b8-4e80-bff0-7e6a249efe8b/OwlTing/owlnest_booking_engine/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ae31b3f')) {
      api.createRecord('7ae31b3f', component.options)
    } else {
      api.reload('7ae31b3f', component.options)
    }
    module.hot.accept("./roomCard.vue?vue&type=template&id=7ae31b3f&scoped=true", function () {
      api.rerender('7ae31b3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Hotel/components/roomCard.vue"
export default component.exports